import React, { useEffect, useRef, useState } from "react";
import { FiRefreshCw } from "react-icons/fi";
import ScreenHeader from "./ScreenHeader";
import MonthlyUtilization from "./MonthlyUtilization";
import GrowthRewards from "./GrowthRewards";
import "./GrowthRewards.css";

export default function PerformanceScreen({ viewUserId = "", viewerEmail = "", employeeEmail = "", growthNew = false, submitRequest, onRequestHandled }) {
  const [tab, setTab] = useState("ga");
  const [refresh, setRefresh] = useState(0);
  const tabs = useRef({});
  useEffect(() => { if (submitRequest) setTab("ga"); }, [submitRequest]);
  const selectWithKeyboard = event => {
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
    event.preventDefault();
    const next = event.key === "Home" ? "ga" : event.key === "End" ? "utilization" : tab === "ga" ? "utilization" : "ga";
    setTab(next); tabs.current[next]?.focus();
  };
  return <section className="new-hrm-screen new-hrm-performance-screen">
    <ScreenHeader title="Performance" actions={<button className="new-hrm-secondary-button" type="button" title="Refresh" aria-label="Refresh" onClick={() => setRefresh(value => value + 1)}><FiRefreshCw aria-hidden="true" /></button>} />
    <div className="hrm-performance-tabs" role="tablist" aria-label="Performance views" onKeyDown={selectWithKeyboard}>
      {[["ga", "GA"], ["utilization", "Utilization"]].map(([id, label]) => <button key={id} ref={element => { tabs.current[id] = element; }} type="button" id={`performance-tab-${id}`} role="tab" aria-label={label} aria-selected={tab === id} aria-controls={`performance-panel-${id}`} tabIndex={tab === id ? 0 : -1} onClick={() => setTab(id)}>{label}{id === "ga" && growthNew && <span className="hrm-growth-launch-badge">New</span>}</button>)}
    </div>
    <div id={`performance-panel-${tab}`} role="tabpanel" aria-labelledby={`performance-tab-${tab}`}>
      {tab === "ga" ? <GrowthRewards key={viewUserId} viewUserId={viewUserId} refreshKey={refresh} submitRequest={submitRequest} onRequestHandled={onRequestHandled} />
        : <MonthlyUtilization viewUserId={viewUserId} viewerEmail={viewerEmail} employeeEmail={employeeEmail} refreshKey={refresh} unavailableMessage="Utilization is not available for this account." />}
    </div>
  </section>;
}
